/**
 * Created by asiulik on 21.12.2017.
 */

define(['./teasersMosaic'], function(TeasersMosaic){

    function Teasers(layoutInstance){
        this.layoutInstance = layoutInstance;
    }

    Teasers.prototype.init = function() {

        var teaserMosaic = new TeasersMosaic(this.layoutInstance);
        teaserMosaic.init();

    };

    return Teasers;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/teasers/teasers.js